module.exports = __webpack_public_path__ + "img/ag.518f076d.jpg";